require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-under-the-stars-lasallian-educators-society.json") })
        }
      }, "path---blog-under-the-stars-lasallian-educators-society");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-under-the-stars-lasallian-educators-society!./.cache/json/blog-under-the-stars-lasallian-educators-society.json
// module id = 388
// module chunks = 231608221292675